import { useSelector } from 'react-redux'

import { getCheckoutItems } from '../../redux/checkout'
import { isAnyCustomerRequestErrorInCheckout } from '../../redux/checkout'

import { CheckoutItemsWrapper } from './CheckoutItemsWrapper'
import { SideBanner } from './SideBanner'
import { SideBannerProps } from './SideBannerProps'

export const CollapsibleItemSideBanner = ({ contractType, displayProductDescription = false }: SideBannerProps) => {
  const checkoutItems = useSelector(getCheckoutItems)
  const isCustomerRequestErrorInCheckout = useSelector(isAnyCustomerRequestErrorInCheckout)

  return (
    <>
      <SideBanner
        checkoutItems={checkoutItems}
        isCustomerRequestErrorInCheckout={isCustomerRequestErrorInCheckout}
        contractType={contractType}
        ItemWrapperComponent={CheckoutItemsWrapper}
        displayProductDescription={displayProductDescription}
      ></SideBanner>
    </>
  )
}
